"use strict";
// packages/contracts/src/pendencia.ts — Fase 10, Plano 02 (D-22..D-24, OMIE-11).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=pendencia.js.map